import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class DialogService {
  constructor(private readonly dialog: MatDialog) {}

  public openDialogComponent({
    component,
    config = {},
  }: {
    component: any;
    config?: any;
  }): MatDialogRef<any> {
    return this.dialog.open(component, config);
  }
}
